import React from 'react';
import {FormattedMessage} from 'react-intl';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import styles from './styles.module.scss';

export const InvoiceOrdersFooter = ({
                                      activeTab,
                                      confirmCustomersCount,
                                      editAndSendCount,
                                    }) => {
  const count = activeTab === 'common'
    ? editAndSendCount
    : confirmCustomersCount;

  return (
    <div className={styles.container}>
      <img
        src={toAbsoluteUrl('media/svg/Info-circle_brandColor.svg')}
        alt="info"
      />
      <FormattedMessage
        id='users-page-footer-total'
        defaultMessage='Number of Records Found - {count}'
        values={{count}}
      />
    </div>
  );
};
